import { makeStyles } from 'tss-react/mui'
import { Theme, alpha } from '@mui/material/styles'
import { CHAT_ON_GRADIENT, CHAT_ON_GRADIENT_DIVIDER } from '../chatColors'

export const useStyles = makeStyles()((theme: Theme) => ({
  controls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  iconButton: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    backgroundColor: 'transparent',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'none',
    padding: 0,
    '& svg': {
      fontSize: 14,
      color: CHAT_ON_GRADIENT,
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.white, 0.15),
    },
  },
  iconButtonActive: {
    backgroundColor: alpha(theme.palette.text.white, 0.25),
  },
  separator: {
    width: 1,
    height: theme.spacing(2.25),
    borderRadius: 17,
    backgroundColor: CHAT_ON_GRADIENT_DIVIDER,
    flexShrink: 0,
  },
  closeButton: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: 8,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    '& svg': {
      fontSize: 14,
      color: CHAT_ON_GRADIENT,
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.white, 0.15),
    },
  },
  layoutPaper: {
    width: theme.spacing(19.5),
    borderRadius: 8,
    border: `1px solid ${theme.palette.stages.hovered}`,
    boxShadow: theme.shadows[3],
  },
  layoutList: {
    padding: `${theme.spacing(0.5)} 0`,
  },
  layoutHeading: {
    padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 11,
    letterSpacing: '0.08em',
    color: theme.palette.labraText.description,
  },
  layoutItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
    fontSize: 13,
    color: theme.palette.labraText.tertiary,
    '& svg': { fontSize: 13 },
  },
  layoutItemActive: {
    backgroundColor: theme.palette.labraChat.hoverBg,
  },
  layoutLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '16px',
    color: 'inherit',
  },
}))
